var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('GChart',{attrs:{"settings":{
                    packages: ['corechart',],
                },"type":_vm.$parent.typeChart,"data":_vm.$parent.chartData,"options":_vm.$parent.chartOptions,"resizeDebounce":500}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }